import { useState } from "react";
import { Copy, Mail, Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { client, formatApiError } from "@/lib/api";

export function buildManualMessage(order) {
  const link = `${window.location.origin}/unduh/${order.download_token}`;
  const subject = `E-book Anda dari ${order.store_name}: ${order.product_name}`;
  const body = `Halo ${order.buyer_name},

Terima kasih telah berbelanja di ${order.store_name}. Pembayaran pesanan ${order.order_id} sudah kami verifikasi.

E-book: ${order.product_name}
Jumlah: ${order.quantity}

Unduh e-book Anda melalui tautan pribadi berikut. Tautan dapat dipakai berulang kali, mohon jangan dibagikan:
${link}

Salam,
${order.store_name}`;
  return { subject, body, link };
}

export function ManualDeliveryDialog({ order, onClose, onSent }) {
  const [recipient, setRecipient] = useState(order.buyer_email);
  const [copied, setCopied] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const { subject, body } = buildManualMessage(order);
  const copy = async (text, what) => { try { await navigator.clipboard.writeText(text); setCopied(what); } catch { setCopied("gagal"); } };
  const mailto = `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  const confirm = async () => {
    setSaving(true); setError("");
    try { await client.post(`/orders/${order.order_id}/deliver/manual`, { recipient_email: recipient, confirm_resend: order.delivery_status === "success" }); onSent(recipient); }
    catch (e) { setError(formatApiError(e, "Gagal mencatat pengiriman.")); }
    finally { setSaving(false); }
  };
  return <Dialog open onOpenChange={open => !open && onClose()}>
    <DialogContent className="manual-dialog" data-testid="manual-delivery-dialog">
      <DialogHeader>
        <DialogTitle>Kirim e-book secara manual</DialogTitle>
        <DialogDescription>Kirim pesan ini dari email toko Anda, lalu tandai sebagai terkirim. Lapak Digitals tidak mengirim email otomatis.</DialogDescription>
      </DialogHeader>
      <label className="manual-field">Email penerima
        <input data-testid="manual-recipient-input" type="email" value={recipient} onChange={e => setRecipient(e.target.value)}/>
      </label>
      <label className="manual-field">Subjek
        <input data-testid="manual-subject-input" readOnly value={subject}/>
      </label>
      <label className="manual-field">Isi pesan
        <textarea data-testid="manual-body-textarea" readOnly value={body} rows={11}/>
      </label>
      {copied && <p className="helper" data-testid="manual-copy-status">{copied === "gagal" ? "Gagal menyalin, salin secara manual." : `${copied} disalin.`}</p>}
      {error && <div className="error" data-testid="manual-error">{error}</div>}
      <div className="manual-actions">
        <button type="button" className="ghost-button" data-testid="manual-copy-email-button" onClick={() => copy(recipient, "Email penerima")}><Copy size={14}/> Salin email</button>
        <button type="button" className="ghost-button" data-testid="manual-copy-body-button" onClick={() => copy(`${subject}\n\n${body}`, "Pesan")}><Copy size={14}/> Salin pesan</button>
        <a className="ghost-button" data-testid="manual-open-mail-link" href={mailto}><Mail size={14}/> Buka aplikasi email</a>
        <button type="button" className="primary-button compact" data-testid="manual-confirm-sent-button" disabled={saving || !recipient} onClick={confirm}><Send size={14}/> {saving ? "Menyimpan…" : "Tandai sudah dikirim"}</button>
      </div>
    </DialogContent>
  </Dialog>;
}
